import {
  LOAD_REQUEST_FAIL,
  LOAD_REQUEST_START,
  LOAD_REQUEST_SUCCESS,
} from "../../actions/actionTypes";

const initialState = {
  loading: false,
  request: {},
  error: "",
  isLoaded: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case LOAD_REQUEST_START:
      return {
        ...state,
        request: {},
        loading: true,
      };
    case LOAD_REQUEST_SUCCESS:
      return {
        ...state,
        loading: false,
        request: { ...action.payload },
        error: "",
        isLoaded: true,
      };
    case LOAD_REQUEST_FAIL:
      return {
        ...state,
        loading: false,
        request: {},
        error: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
